import { Chance } from "chance"
import { DictionaryUser } from "etl/types";

const chance = new Chance();

export const dictionaryUserFactoryMock = (howMany: number): DictionaryUser[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/dictionary_users/${index + 1}`,
		id: index + 1,
		libelle_audio: chance.name(),
		etl_errored: chance.bool(),
		etl_message: chance.sentence(),
		aw_laboratory_id: chance.integer().toString(),
		// etl_ignored: chance.boolean().toString(),
		aw_import_id: chance.integer().toString()
	}));
